export default __webpack_public_path__ + "static/media/NLP.b6105374.png";